/**
 * 中文语言包 (简体中文)
 */
export default {
  // 通用
  common: {
    language: '语言',
    cancel: '取消',
    confirm: '确认',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    add: '添加',
    search: '搜索',
    loading: '加载中...',
    success: '操作成功',
    error: '操作失败',
    networkError: '网络错误，请稍后重试',
    help: '帮助',
    logout: '退出',
    welcome: '欢迎，{{username}}',
    get copyright() {
      // 延迟求值，确保 window.PidocBrand 已加载
      return (
        '版权所有 © 2026 ' +
        ((window.PidocBrand && window.PidocBrand.copyright) || 'pidoc.cn') +
        '。'
      );
    },
    feedback: '远程管理免费使用。大量设备加入请入群知会。系统问题或建议反馈 → QQ群：498908352',
    close: '关闭',
    refresh: '刷新',
    totalRecords: '共 {{count}} 条记录',
    devices: '共 {{count}} 台设备',
    operation: '操作',
    unauthorized: '未授权',
    loginExpired: '登录已过期，请重新登录',
    adminAuthFailed: '认证失败，请检查管理员权限',
    copiedToClipboard: '已复制到剪贴板',
    copyFailed: '复制失败',
    copy: '复制',
    reset: '重置',
    create: '创建',
    active: '启用',
    inactive: '停用',
    enabled: '启用',
    disabled: '禁用',
    show: '显示',
    hide: '隐藏',
    copied: '已复制',
  },

  // 登录页面
  login: {
    title: 'PiDOC',
    subtitle: '远程设备管理',
    username: '用户名',
    usernamePlaceholder: '用户名',
    usernameRequired: '请输入用户名',
    password: '密码',
    passwordPlaceholder: '密码',
    passwordRequired: '请输入密码',
    loginButton: '登录',
    loginSuccess: '登录成功！',
    loginFailed: '登录失败',
    tooManyAttempts: '登录失败次数过多，请稍后再试',
    noAccount: '还没有账号？立即注册',
    forgotPassword: '忘记密码？',
    emailNotVerified: '请先验证邮箱后再登录',
  },

  // 注册页面
  register: {
    title: '注册账号',
    username: '用户名',
    usernamePlaceholder: '用户名 (3-20个字母或数字)',
    usernameRequired: '请输入用户名',
    usernameMin: '用户名至少3个字符',
    usernameMax: '用户名最多20个字符',
    usernamePattern: '用户名只能包含字母和数字',
    email: '邮箱',
    emailPlaceholder: '邮箱',
    emailRequired: '请输入邮箱',
    emailInvalid: '请输入有效的邮箱地址',
    password: '密码',
    passwordPlaceholder: '密码 (至少6个字符)',
    passwordRequired: '请输入密码',
    passwordMin: '密码至少6个字符',
    confirmPassword: '确认密码',
    confirmPasswordPlaceholder: '确认密码',
    confirmPasswordRequired: '请确认密码',
    confirmPasswordMismatch: '两次输入的密码不一致',
    registerButton: '注册',
    registerSuccess: '注册成功！',
    registerFailed: '注册失败',
    haveAccount: '已有账号？立即登录',
    emailSent: '验证邮件已发送，请查收邮箱并点击验证链接',
    redirectingIn: '{{seconds}} 秒后自动跳转到登录页面',
  },

  // 忘记密码页面
  forgotPassword: {
    title: '找回密码',
    emailSent: '邮件已发送',
    emailPlaceholder: '注册邮箱',
    emailRequired: '请输入邮箱地址',
    emailInvalid: '请输入有效的邮箱地址',
    sendButton: '发送重置邮件',
    backButton: '返回登录',
    successMessage: '请查收密码重置邮件',
    instruction: '我们已向您的邮箱发送了密码重置链接，<br/>请在 1 小时内点击链接完成密码重置。',
  },

  // 重置密码页面
  resetPassword: {
    title: '重置密码',
    newPassword: '新密码',
    newPasswordPlaceholder: '新密码（至少6个字符）',
    newPasswordRequired: '请输入新密码',
    newPasswordMin: '密码至少6个字符',
    confirmPassword: '确认新密码',
    confirmPasswordPlaceholder: '确认新密码',
    confirmPasswordRequired: '请再次输入新密码',
    confirmPasswordMismatch: '两次输入的密码不一致',
    resetButton: '重置密码',
  },

  // 仪表盘
  dashboard: {
    overview: '概览',
    metrics: '指标监控',
    devices: '设备管理',
    keys: '密钥管理',
    bandwidth: '带宽监控',
    ssh: '远程访问',
    messages: '站内消息',
    forward: '应用转发',
    installTokens: '安装令牌',
  },

  // 网页转发
  forward: {
    subdomain: '子域名',
    subdomainRequired: '请填写子域名',
    subdomainPattern: '小写字母开头，只含小写字母/数字/连字符，最长20位',
    targetDevice: '目标设备',
    targetPort: '目标端口',
    target: '目标',
    pathPrefix: '路径前缀',
    selectDevice: '选择设备',
    addRoute: '添加转发路由',
    editRoute: '编辑转发路由',
    forwardHint: 'HTTP 转发仅在 Ops 平台登录有效时生效。Ops 登录有效期 30 天。',
    webForward: '网页转发',
    mcForward: 'MC 服务器转发',
    mcServerAddress: '服务器地址',
    mcTarget: '目标设备:端口',
    mcHint: '在 Minecraft 客户端中填写对应的服务器地址（如 myserver.mc.pidoc.cn:25565）即可连接到你的设备。子域名全局唯一，创建后不可修改。',
    mcDeleteTitle: '删除MC转发',
    mcDeleteConfirm: '确定删除 "{subdomain}.mc.pidoc.cn" 的转发配置吗？',
    mcAddModal: '新建MC转发',
    mcEditModal: '编辑MC转发',
    mcSubdomainLabel: '子域名',
    mcSubdomainRequired: '请填写子域名',
    mcSubdomainPattern: '小写字母开头，只含小写字母/数字/连字符，最长20位',
    mcTargetDevice: '目标设备',
    mcTargetDeviceRequired: '请选择设备',
    mcTargetPort: '目标端口',
    mcTargetPortRequired: '请填写端口',
    mcSelectDevice: '选择设备',
    // V2 网页转发
    loadFailed: '获取转发列表失败',
    confirmDeleteTitle: '删除转发',
    confirmDelete: '确定删除 "{subdomain}" 的转发配置吗？',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    fillAllFields: '请填写所有字段',
    updateSuccess: '更新成功',
    createSuccess: '创建成功',
    operationFailed: '操作失败',
    device: '设备',
    port: '端口',
    title: '网页转发',
    add: '添加',
    edit: '编辑',
    subdomainPlaceholder: '请输入子域名',
    pathPrefixPlaceholder: '请输入路径前缀，如 /api',
  },

  // 设备管理
  deviceManagement: {
    title: '设备管理',
    deviceAlias: '设备别名',
    hostname: '主机名',
    system: '系统',
    terminalVersion: '终端版本',
    connectionStatus: '连接状态',
    online: '在线',
    offline: '离线',
    actions: '操作',
    detail: '详情',
    history: '历史',
    edit: '编辑',
    evict: '驱逐',
    evictConfirm: '确定要驱逐设备 "{{name}}" 吗？驱逐后该设备及其认证密钥将被永久删除。',
    evictSuccess: '驱逐成功',
    evictFailed: '驱逐失败',
    evictTitle: '驱逐设备',
    add: '增加',
    loadFailed: '获取设备列表失败',
    unhealthy: '异常',
    healthReasons: {
      expired_key: '密钥已过期，请生成新密钥后再次安装',
      wrong_device: '密钥不属于此设备，请生成新密钥后再次安装',
      duplicate_connection: '设备已在线，存在重复连接',
      timeout: '连接超时',
      app_not_running: '应用未运行',
      network_error: '网络异常',
    },
    detailTitle: '设备详情',
    basicInfo: '基本信息',
    systemInfo: '系统信息',
    runMode: '运行模式',
    runModeUser: '用户模式',
    runModeSystem: '系统模式',
    serialNumber: '设备编号',
    createTime: '创建时间',
    lastOnline: '最后上线',
    updateTime: '更新时间',
    os: '操作系统',
    osVersion: '系统版本',
    editTitle: '编辑设备',
    aliasPlaceholder: '为设备设置一个易识别的名称',
    aliasRule: '设备别名仅允许使用小写字母（a-z）、数字（0-9）和连字符（-），必须以字母开头，长度不超过32个字符。',
    updateSuccess: '更新成功',
    updateFailed: '更新失败',
    connectionHistory: '连接历史',
    serverAddr: '服务器地址',
    connectTime: '连接时间',
    disconnectTime: '断开时间',
    duration: '持续时长',
    clientIP: '客户端IP',
    disconnectReason: '断开原因',
    keyDetail: '密钥详情',
    existingKey: '已存在未绑定的密钥',
    existingKeyWarning: '已存在未绑定的有效密钥',
    keyName: '密钥名称',
    expireTime: '过期时间',
    existingKeyTip: '一个账号只能有一个未绑定的有效密钥。如需创建新密钥，请先删除现有密钥。',
    installCommand: '安装命令',
    installCommandWarning: '⚠️ 仅显示一次',
    installCommandTip: '⚠️ 密钥有效期6小时，仅可绑定一台设备。请立即复制安装命令到设备上运行。',
    installStep1: '第1步：下载安装 PiDOC 客户端',
    installStep2: '第2步：注册到设备',
    // 新版：选择安装令牌生成安装命令
    selectInstallTokenTitle: '增加设备 - 选择安装令牌',
    selectInstallToken: '选择安装令牌',
    installTokenEmpty: '暂无可用安装令牌，请先到密钥管理 → 安装令牌创建',
    username: '安装账号',
    installCommandForToken: '安装命令（将自动填入所选令牌与当前账号）',
    copyInstallCommand: '复制安装命令',
    installCommandCopied: '安装命令已复制',
    globalEditionTip: '当前为 Global 版本（inst.sh），暂不支持 --customtoken 参数，请改用「种子密钥」方式或等待脚本更新。',
    bindDevice: '绑定设备',
    openInstallTokenManagement: '去创建安装令牌',
    step1Install: '第 1 步：安装 PiDOC 客户端',
    step2InstallService: '第 2 步：注册到设备',
    installStep2Warning: '⚠️ 此密钥仅显示一次。请立即在设备上运行命令。',
    copiedToClipboard: '安装命令已复制到剪贴板',
    keyCreated: '密钥创建成功',
    keyCreateFailed: '创建密钥失败',
    keyCheckFailed: '检查密钥失败',
    keyDeleted: '密钥已删除',
    keyDeleteFailed: '删除失败',
    tags: '标签',
    tagPlaceholder: '输入标签名，回车确认',
    tagAddTag: '添加标签',
    tagSearch: '搜索标签...',
    tagRule: '标签只能包含小写字母、数字、连字符和下划线，最多 30 字符',
    tagExists: '标签已存在',
    fullInstallGuide: '完整安装指南',
    viewFullGuide: '查看完整安装指南',
    show: '显示',
    hide: '隐藏',
    uploadDownload: '速率',
    allStatus: '全部状态',
    allMode: '全部模式',
    lastSeen: '最近在线',
    updated: '更新时间',
  },

  // 安装令牌管理
  installTokenManagement: {
    title: '安装令牌',
    tip: '安装令牌用于设备首次安装时的一键兑换：在安装脚本中传入令牌即可自动兑换登录密钥并完成设备注册。',
    create: '新建令牌',
    createTitle: '新建安装令牌',
    editTitle: '编辑安装令牌',
    token: '令牌',
    tokenPlaceholder: '请输入令牌（可见字符，不含空格，6-20 位）',
    tokenHint: '令牌由您手工编写，安装时设备用此令牌兑换登录密钥；创建后不可修改。',
    tokenInvalid: '令牌格式不正确（仅可见字符，不含空格，长度 6-20）',
    note: '备注',
    notePlaceholder: '请输入备注信息',
    tags: '标签',
    tagsPlaceholder: '输入标签后回车，多个标签用逗号分隔',
    enabled: '启用',
    usedCount: '使用次数',
    createdAt: '创建时间',
    operation: '操作',
    edit: '编辑',
    delete: '删除',
    confirmDelete: '确定删除该安装令牌吗？删除后已使用该令牌的设备不受影响。',
    confirmDeleteTitle: '删除安装令牌',
    createSuccess: '创建成功',
    updateSuccess: '更新成功',
    deleteSuccess: '删除成功',
    createFailed: '创建失败',
    updateFailed: '更新失败',
    deleteFailed: '删除失败',
    loadFailed: '获取令牌列表失败',
    networkError: '网络错误，请稍后重试',
    empty: '暂无安装令牌',
    installCommand: '安装命令',
    copyInstall: '复制安装命令',
  },

  // 概览页面
  overview: {
    onlineDevices: '在线设备数',
    boostBalance: '加速流量余额',
    totalUpload24h: '总上传（24h）',
    totalDownload24h: '总下载（24h）',
    aiTodayRequests: 'AI 对话次数（今日）',
    aiTodayTokens: 'AI Token 用量（今日）',
    aiUsageEmpty: '暂无使用',
    request: '请求',
    token: 'Token',
    accountInfo: '账号信息',
    username: '用户名',
    email: '邮箱',
    registerTime: '注册时间',
    accountSecurity: '账号安全',
    keyManagement: '密钥管理',
    changePassword: '修改密码',
    versionHistory: '版本记录',
    currentVersion: '当前',
    showMore: '更多',
    showLess: '收起',
    passwordMismatch: '两次输入的新密码不一致',
    passwordChanged: '密码修改成功，请重新登录',
    passwordChangeFailed: '修改密码失败',
    oldPassword: '原密码',
    oldPasswordPlaceholder: '请输入原密码',
    oldPasswordRequired: '请输入原密码',
    newPassword: '新密码',
    newPasswordPlaceholder: '请输入新密码（至少6个字符）',
    newPasswordRequired: '请输入新密码',
    newPasswordMin: '密码至少6个字符',
    confirmNewPassword: '确认新密码',
    confirmNewPasswordPlaceholder: '请再次输入新密码',
    confirmNewPasswordRequired: '请再次输入新密码',
    confirmPasswordMismatch: '两次输入的密码不一致',
    confirmPassword: '确认密码',
    confirmPasswordPlaceholder: '请再次输入新密码',
    changePasswordWarning: '修改密码后需要重新登录，请确保记住新密码。',
    changePasswordTip: '⚠️ 提示：',
    changePasswordTip1: '• 修改密码后需要重新登录',
    changePasswordTip2: '• 请确保记住新密码',
    confirmChange: '确认修改',
  },

  // 密钥管理
  keyManagement: {
    fortressKey: '堡垒密钥',
    agentKey: 'Agent密钥',
  },

  // Agent 密钥管理 (合并 V1 + V2)
  agentKeyManagement: {
    loadFailed: '获取密钥列表失败',
    networkError: '网络错误',
    createSuccess: 'Agent密钥创建成功！',
    createFailed: '创建失败',
    confirmRegenerateTitle: '重新生成种子',
    confirmRegenerate: '确定要重新生成种子吗？重新生成后旧种子将失效。',
    regenerateWarning: '重新生成后，旧密钥将失效，使用该密钥的连接将被断开。继续吗？',
    regenerateSuccess: '种子重新生成成功',
    regenerateFailed: '种子重新生成失败',
    confirmDeleteTitle: '删除密钥',
    confirmDelete: '确定要删除密钥 "{{name}}" 吗？删除后不可恢复。',
    deleteSuccess: '密钥删除成功',
    deleteFailed: '密钥删除失败',
    confirmRevoke: '确认吊销',
    revokeWarning: '吊销后，使用该密钥的连接将被断开。吊销？',
    revokeSuccess: '吊销成功',
    revokeFailed: '吊销失败',
    key: '密钥',
    keyName: '密钥名称',
    seed: '种子',
    createdAt: '创建时间',
    expiresAt: '过期时间',
    copy: '复制',
    keyCopied: '密钥已复制到剪贴板',
    regenerate: '重新生成',
    revoke: '吊销',
    createAgentKey: '创建Agent密钥',
    maxKeyLimit: '每个账户最多只能有一个Agent密钥',
    confirmCreate: '确认创建Agent密钥吗？',
    createTip1: '• 每个账户只能有一个Agent密钥',
    createTip2: '• Agent密钥用于Pidoc Agent工具',
    createTip3: '• 请妥善保管好Agent密钥',
    title: 'Agent 密钥管理',
    create: '创建密钥',
    createWarning: '⚠️ 密钥仅显示一次',
    keyDetail: '密钥详情',
    installTip: '⚠️ 请在设备上运行安装命令',
    show: '显示',
    hide: '隐藏',
  },

  // Proxy 密钥管理 (合并 V1 + V2)
  proxyKeyManagement: {
    loadFailed: '获取密钥列表失败',
    networkError: '网络错误',
    createSuccess: '密钥创建成功！',
    publicKeyAdded: '公钥添加成功！',
    createFailed: '创建失败',
    confirmRevoke: '确认吊销',
    revokeWarning: '吊销后，使用该私钥的设备将无法连接。吊销？',
    revokeSuccess: '吊销成功',
    revokeFailed: '吊销失败',
    updateSuccess: '更新成功',
    updateFailed: '更新失败',
    keyName: '密钥名称',
    keyType: '密钥类型',
    fortressKey: '堡垒密钥',
    agentKey: 'Agent密钥',
    fortressKeyTip: '堡垒密钥用于设备连接认证，请在创建后复制到设备。',
    agentKeyTip: 'Agent 密钥用于 Agent 模式连接认证。',
    publicKey: '公钥',
    seed: '种子',
    status: '状态',
    createdAt: '创建时间',
    title: 'Proxy 密钥管理',
    create: '创建密钥',
    createProxyKey: '创建堡垒密钥',
    maxKeyLimit: '每个账户最多只能有五个密钥（包含Agent密钥）',
    createNewKey: '创建新密钥',
    keyNamePlaceholder: '例如: my-proxy-key',
    keyNameRequired: '请输入密钥名称',
    createMode: '创建方式',
    autoGenerate: '自动生成密钥对',
    useExisting: '使用已有公钥',
    publicKeyContent: '公钥内容',
    publicKeyPlaceholder: 'ssh-ed25519 AAAA...',
    publicKeyRequired: '请输入公钥内容',
    expiresAt: '过期时间',
    confirmDeleteTitle: '删除代理密钥',
    confirmDelete: '确定要删除该代理密钥吗？删除后不可恢复。',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    publicKeyTip: '粘贴 OpenSSH 格式公钥（如 ssh-ed25519 AAAA...）',
    keyDetail: '密钥详情',
    privateKeyDownload: '私钥下载',
    downloadNow: '⚠️ 请立即下载',
    importantNotice: '⚠️ 重要提示',
    privateKeyWarning: '私钥不在服务器保存，请立即下载并妥善保管！关闭此窗口后将无法再次下载。',
    downloadPrivateKey: '下载私钥文件',
    downloadSuccess: '私钥下载成功！请妥善保管',
    downloadFailed: '下载失败: {{error}}',
    usageGuide: '使用指南',
    savePrivateKey: '1. 保存私钥到本地文件',
    changePermission: '2. 修改文件权限',
    configureSSH: '3. 配置 SSH Config（可选）',
    editKeyName: '编辑密钥名称',
    show: '显示',
    hide: '隐藏',
  },

  // 邮箱验证
  verifyEmail: {
    pageTitle: '邮箱验证 - pidoc',
    title: '邮箱验证',
    success: '验证成功',
    failed: '验证失败',
    redirecting: '{{seconds}} 秒后自动跳转到登录页...',
    gotoLogin: '立即前往登录',
    backHome: '返回首页',
    footer: 'pidoc - 远程设备管理平台',
    home: '首页',
    contactSupport: '联系支持',
    // 验证结果 - Title
    successTitle: '邮箱验证成功！',
    missingToken: '缺少验证令牌',
    invalidLink: '验证失败',
    expiredLink: '验证链接已过期',
    systemError: '验证失败',
    // 验证结果 - Message
    successMessage: '您的邮箱已成功验证，即将跳转到登录页面...',
    missingTokenMessage: '链接无效或已过期，请重新注册或联系管理员。',
    invalidLinkMessage: '验证链接无效，可能已被使用或不存在。',
    expiredLinkMessage: '该验证链接已过期，请重新注册或联系管理员重新发送验证邮件。',
    systemErrorMessage: '系统错误：{{error}}',
  },

  // SSH 页面
  ssh: {
    title: '终端 & 文件管理',
    pleaseLogin: '请先登录',
    backToLogin: '返回登录',
    noConnection: '暂无连接',
    newConnection: '+ 新建连接',
    newConnectionTitle: '新建连接',
    connectionMode: '连接模式',
    sshMode: 'SSH 终端',
    sftpMode: 'SFTP 文件',
    vncMode: 'VNC 桌面',
    selectDevice: '选择设备',
    selectDevicePlaceholder: '请选择设备',
    selectDeviceRequired: '请选择设备',
    username: '用户名',
    usernamePlaceholder: '例如: root',
    usernameRequired: '请输入用户名',
    port: '端口',
    portPlaceholder: '默认: 22',
    portRequired: '请输入端口',
    authMethod: '认证方式',
    authMethodRequired: '请选择认证方式',
    passwordAuth: '密码认证',
    privateKeyAuth: '私钥认证',
    password: '密码',
    passwordPlaceholder: '请输入密码',
    passwordRequired: '请输入密码',
    privateKey: '私钥文件',
    privateKeyPlaceholder: '选择私钥文件',
    privateKeyRequired: '请上传私钥文件',
    privateKeyLoaded: '✓ 私钥已加载 ({{preview}}...)',
    serviceHintSsh: '需要您的设备开启了 SSH 服务，才能正常访问。PiDOC 并不会自动启用相关服务。',
    serviceHintVnc: '需要您的设备开启了 VNC 服务，才能正常访问。PiDOC 并不会自动启用相关服务。',
    serviceHintDocLink: '如何开启，请查看',
    serviceHintDocUrl: 'https://pidoc.cn/docs/computers/remote-access',
    connect: '连接',
    connectionFailed: 'SSH 连接失败',
    deviceNotFound: '设备不存在',
    loadDevicesFailed: '加载设备列表失败',
    loginExpired: '登录已过期，请重新登录',
    sftpConnectionFailed: 'SFTP 连接失败',
    refreshWarning: '刷新页面会导致所有SSH/SFTP连接丢失，确定要继续吗？',
    useAgent: '使用 ssh-agent 免密登录',
    useAgentHint: '勾选后将通过本地 ssh-agent 免密连接（仅用户模式设备支持）',
    agentUnavailable: 'ssh-agent 免密登录不可用，已切换为密码/私钥登录，请补充凭据后重连',
  },

  // 指标监控
  metrics: {
    minutes: '分钟',
    hours: '小时',
  },

  // 带宽监控
  bandwidthMonitoring: {
    title: '带宽监控',
    autoRefresh: '自动刷新',
    refresh: '刷新',
    bandwidthConfig: '带宽配置（动态分配模式）',
    baseBandwidth: '每设备基础带宽（独享）',
    globalBoostPool: '全局加速池（共享）',
    boostTrafficBalance: '加速流量余额',
    onlineDevices: '在线设备数',
    boostEnabled: '加速已启用，高需求设备获得更多带宽。',
    boostDisabled: '余额不足15MB，仅基础带宽可用。',
    trafficSummary: '流量汇总（最近24小时）',
    totalUpload: '总上传',
    totalDownload: '总下载',
    totalTraffic: '总流量',
    deviceRealtimeTraffic: '设备实时流量',
    realtimeTrafficTip: '提示：设备在线但无流量时，速率和累计流量均为0',
    noOnlineDevices: '暂无在线设备',
    deviceAlias: '设备别名',
    online: '在线',
    uploadRate: '上传速率',
    downloadRate: '下载速率',
    totalRate: '总速率',
    cumulativeTraffic: '累计流量',
    connectionTime: '连接时间',
    viewStatistics: '查看统计',
    deviceTrafficStats: '设备流量统计',
    close: '关闭',
    time: '时间',
    upload: '上传',
    download: '下载',
    averageRate: '平均速率',
    rewardedBoostTraffic: '奖励加速流量',
    consumedBoostTraffic: '消耗加速流量',
    fetchBandwidthConfigFailed: '获取带宽配置失败',
    fetchTrafficSummaryFailed: '获取流量汇总失败',
    fetchDeviceTrafficStatsFailed: '获取设备流量统计失败',
  },

  // 设备卡片
  deviceCard: {
    sshConnect: 'SSH连接',
    vncRemoteDesktop: 'VNC远程桌面',
    rdpRemoteDesktop: 'RDP远程桌面',
    edit: '编辑',
    delete: '删除',
    serialNumber: '序列号',
    hostname: '主机',
    deviceOffline: '设备当前离线',
  },

  // 站内消息
  messages: {
    title: '站内消息',
    feedbackTab: '反馈消息',
    systemTab: '系统消息',
    sendMessage: '发送消息',
    sendTitle: '发送消息',
    titleLabel: '标题',
    titlePlaceholder: '请输入消息标题',
    titleRequired: '请输入标题',
    titleMax: '标题不超过200字',
    contentLabel: '内容',
    contentPlaceholder: '请输入消息内容',
    contentRequired: '请输入内容',
    sendSuccess: '消息发送成功',
    sendFailed: '发送失败',
    replySuccess: '回复成功',
    replyFailed: '回复失败',
    replyPlaceholder: '输入回复内容...',
    reply: '回复',
    replyCount: '回复',
    replyEmpty: '请输入回复内容',
    addAttachment: '添加附件',
    attachmentLimit: '附件数量不能超过{{max}}个',
    attachmentSizeLimit: '文件大小不能超过5MB',
    attachmentUploadSuccess: '附件上传成功',
    attachmentUploadFailed: '上传失败',
    statusFilter: '状态过滤',
    statusUnread: '未读',
    statusRead: '已读',
    statusClosed: '已关闭',
    markAsRead: '标为已读',
    batchReadSuccess: '已批量标记为已读',
    close: '关闭',
    batchClose: '关闭',
    batchCloseTitle: '批量关闭',
    batchCloseConfirm: '确定要关闭选中的 {{count}} 条消息吗？关闭后不可回复。',
    batchCloseSuccess: '已批量关闭',
    operationFailed: '操作失败',
    sender: '发送者',
    status: '状态',
    time: '时间',
    detail: '消息详情',
    loading: '加载中...',
    listFailed: '获取消息列表失败',
    detailFailed: '获取消息详情失败',
    unreadCountFailed: '查询未读数量失败',
    total: '共 {{count}} 条',
    admin: '管理员',
    networkError: '网络错误',
    fileEmpty: '文件内容为空',
    noReplyAllowed: '系统消息不支持回复',
    messageClosed: '消息已关闭',
    justNow: '刚刚',
    ago: '前',
  },

  // 管理后台
  admin: {
    // 通用
    networkError: '网络错误',
    justNow: '刚刚',
    minutesAgo: '{{count}}分钟前',
    hoursAgo: '{{count}}小时前',
    close: '关闭',
    detail: '详情',
    refresh: '刷新',
    search: '搜索',
    reset: '重置',
    cancel: '取消',
    send: '发送',
    reply: '回复',
    copy: '复制',
    copiedToClipboard: '已复制到剪贴板',
    copyFailed: '复制失败',
    totalRecords: '共 {{count}} 条记录',
    totalOnlineDevices: '共 {{count}} 台在线设备',

    // 消息管理
    messageManagement: '站内消息管理',
    sendToUser: '单发消息给用户',
    broadcastToAll: '群发消息给全部用户',
    singleSend: '单发',
    singleSendMessage: '单发消息',
    broadcast: '群发',
    broadcastMessage: '群发消息',
    feedbackMessages: '反馈消息',
    systemMessages: '系统消息',
    title: '标题',
    sender: '发送者',
    status: '状态',
    time: '时间',
    action: '操作',
    statusClosed: '已关闭',
    statusUnread: '未读',
    statusRead: '已读',
    recipientUserId: '接收者用户ID',
    enterUserId: '输入用户ID',
    pleaseEnterUserId: '请输入用户ID',
    pleaseEnterTitle: '请输入标题',
    titleMaxLength: '标题不超过200字',
    enterMessageTitle: '请输入消息标题',
    content: '内容',
    pleaseEnterContent: '请输入内容',
    enterMessageContent: '请输入消息内容',
    addAttachment: '添加附件',
    maxAttachments: '最多{{count}}个附件',
    fileSizeLimit: '文件大小不能超过5MB',
    attachmentUploaded: '附件上传成功',
    uploadFailed: '上传失败',
    messageSent: '消息发送成功',
    sendFailed: '发送失败',
    broadcastSent: '群发消息成功',
    broadcastFailed: '群发失败',
    pleaseEnterReply: '请输入回复内容',
    enterReplyContent: '输入回复内容...',
    replySent: '回复发送成功',
    replyFailed: '回复失败',
    messageClosed: '消息已关闭',
    closeFailed: '关闭失败',
    loadMessagesFailed: '获取消息列表失败',
    loadDetailFailed: '获取消息详情失败',
    messageDetail: '消息详情',
    replyCount: '回复',

    // 用户管理
    userManagement: '用户管理',
    totalUsers: '总用户数',
    activeUsers: '正常用户',
    bannedLabel: '已封禁',
    verifiedEmail: '已验证邮箱',
    totalDevicesLabel: '总设备数',
    onlineDevicesLabel: '在线设备数',
    userList: '用户列表',
    username: '用户名',
    email: '邮箱',
    deviceCount: '设备数',
    online: '在线',
    keyCount: '密钥数',
    registerTime: '注册时间',
    ban: '封禁',
    unban: '解封',
    confirmBanUser: '确认封禁用户',
    confirmBanContent: '确定要封禁用户 "{{name}}" 吗？封禁后该用户将无法登录。',
    userBanned: '用户已封禁',
    banFailed: '封禁失败',
    confirmUnbanUser: '确认解封用户',
    confirmUnbanContent: '确定要解封用户 "{{name}}" 吗？',
    userUnbanned: '用户已解封',
    unbanFailed: '解封失败',
    loadUsersFailed: '获取用户列表失败',
    loadDevicesFailed: '获取设备列表失败',
    loadKeysFailed: '获取密钥列表失败',
    userDetail: '用户详情',
    statusNormal: '正常',
    verified: '已验证',
    unverified: '未验证',
    lastLogin: '最后登录',
    neverLoggedIn: '从未登录',
    deviceList: '设备列表',
    keyList: '密钥列表',
    searchPlaceholder: '搜索用户名/邮箱/ID',
    deviceAlias: '设备别名',
    serialNumber: '序列号',
    hostname: '主机名',
    system: '系统',
    terminalVersion: '终端版本',
    connectionStatus: '连接状态',
    onlineStatus: '在线',
    offlineStatus: '离线',
    lastOnline: '最后上线',
    createTime: '创建时间',
    keyName: '密钥名称',
    purpose: '用途',
    purposeClient: '客户端',
    purposeProxy: '代理',
    publicKey: '公钥',

    // 在线设备
    onlineDevices: '在线设备',
    devicesCount: '{{count}} 台',
    searchDevicePlaceholder: '搜索设备/用户/主机名',
    autoRefreshOn: '开',
    autoRefreshOff: '关',
    loadOnlineDevicesFailed: '获取在线设备失败',
    deviceId: '设备 ID',
    user: '用户',
    ip: 'IP',
    proxy: '代理',
    connectionType: '连接类型',
    statusOnline: '在线',
    connectionTime: '连接时间',
    onlineTime: '上线时间',
    proxyStats: '按Proxy统计：',
    deviceDetail: '设备详情',
    connectionMethod: '连接方式',
    systemType: '系统类型',
    systemVersion: '系统版本',
    proxyId: 'Proxy ID',
    lastHeartbeat: '最后心跳',
    deviceCreateTime: '设备创建时间',
    daysAgo: '{{count}}天前',

    // 转发记录
    forwardRecords: '转发记录',
    userId: '用户ID',
    type: '类型',
    startTime: '开始时间',
    endTime: '结束时间',
    ongoing: '进行中',
    duration: '时长',
    uploadMB: '上传(MB)',
    downloadMB: '下载(MB)',
    totalTrafficMB: '总流量(MB)',
    sourceAddr: '来源地址',
    sourcePort: '来源端口',
    destAddr: '目标地址',
    destPort: '目标端口',
    searchUserPlaceholder: '搜索用户ID/用户名',
    forwardTypeFilter: '转发类型',
    all: '全部',
    dateFrom: '开始日期',
    dateTo: '结束日期',
    filterMinTraffic: '过滤<1MB',
    loadForwardRecordsFailed: '获取转发记录失败',
    adminLoggedIn: '管理员已登录',

    // 菜单
    menuUsers: '用户',
    menuOnlineDevices: '在线设备',
    menuForwardRecords: '转发记录',
    menuMessages: '消息',
    menuServices: '服务发现',
    menuDeviceConnections: '设备连接',
    proxyServices: 'Pidoc Proxy 服务',
    webServices: 'Pidoc Web 服务',
    region: '区域',
    domain: '域名',
    address: '地址',
    capacity: '容量',
    load: '负载',
    version: '版本',
    versionNotReported: '未上报',
    startedAt: '启动时间',
    noServices: '暂无服务注册',
    loadServicesFailed: '加载服务列表失败',
  },

  // SFTP 文件管理器
  sftp: {
    connectionFailed: 'SFTP 连接失败',
    closeSessionFailed: '关闭会话失败',
    loginExpired: '登录已过期',
    readDirFailed: '读取目录失败',
    downloadFailed: '下载失败',
    downloadStarted: '开始下载: {{name}}',
    downloadComplete: '下载完成: {{name}} ({{size}})',
    confirmDelete: '确认删除',
    confirmDeleteContent: '确定要删除 "{{name}}" 吗？此操作不可撤销。',
    deleteBtn: '删除',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    confirmBatchDelete: '确认批量删除',
    confirmBatchDeleteContent: '确定要删除 {{count}} 个选中项吗？此操作不可撤销。',
    batchDeleteSuccess: '已删除 {{ok}} 项',
    batchDeletePartial: '删除 {{ok}} 项成功，{{fail}} 项失败',
    filenameNoSlash: '文件名不能包含 /',
    renameSuccess: '重命名成功',
    renameFailed: '重命名失败',
    mkdirSuccess: '创建成功',
    mkdirFailed: '创建失败',
    preparing: '准备上传: {{name}} ({{size}})',
    uploadFailed: '上传失败',
    wsCreateFailed: 'WebSocket 创建失败',
    networkErrorMsg: '网络错误',
    cancelled: '已取消',
    batchUploadSuccess: '已上传 {{ok}} 个文件',
    batchUploadPartial: '上传 {{ok}} 个成功，{{fail}} 个失败',
    singleUploadSuccess: '上传成功: {{name}}',
    parentDir: '上级',
    refreshBtn: '刷新',
    newFolder: '新建文件夹',
    uploadFile: '上传文件',
    loadingText: '加载中...',
    emptyDropHint: '目录为空，可拖拽文件到此上传',
    emptyDropRelease: '松开鼠标上传文件',
    fileName: '名称',
    fileSize: '大小',
    modifiedTime: '修改时间',
    permissions: '权限',
    rootDir: '根目录',
    upload: '上传',
    download: '下载',
    downloadFiles: '下载 {{count}} 个文件',
    deleteItems: '删除 {{count}} 项',
    downloadSingle: '下载',
    renameSingle: '重命名',
    deleteSingle: '删除',
    newFolderMenu: '新建文件夹',
    itemCount: '{{count}} 个项目',
    selectedItem: '已选择: {{name}}',
    selectedItems: '已选择 {{count}} 项',
    remainingTime: '剩余 {{time}}',
    renameTitle: '重命名',
    newFolderTitle: '新建文件夹',
    create: '创建',
    folderNamePlaceholder: '文件夹名称',
    seconds: '{{n}}秒',
    minutesSeconds: '{{m}}分{{s}}秒',
    hoursMinutes: '{{h}}时{{m}}分',
    queueCount: ' | 队列中: {{count}} 个文件',
    dropNothing: '未识别到可上传的文件',
    dropUnsupported: '暂不支持上传文件夹或空文件',
    dropPartialSkipped: '已跳过 {{n}} 个文件夹/空文件',
    overwriteTitle: '文件已存在',
    overwriteContent: '目标目录中已存在同名文件：{{names}}。继续上传将覆盖原有内容，且无法恢复。',
    overwriteConfirm: '覆盖上传',
    confirmDeleteDir: '确认删除目录',
    confirmDeleteDirContent:
      '目录 {{name}} 及其内部的全部内容将被永久删除，此操作不可恢复。',
  },

  // SSH 终端
  sshTerminal: {
    sessionNotFound: '会话不存在',
    connectingToDevice: '正在连接到设备...',
    wsConnected: '● WebSocket 连接成功',
    authenticating: '正在认证...',
    errorPrefix: '✗ 错误: ',
    disconnected: '● 连接已断开 (code: {{code}})',
    wsError: '✗ WebSocket 错误',
    connectionFailed: '连接失败: ',
  },

  // VNC 远程桌面
  vnc: {
    noVncNotLoaded: 'noVNC 库尚未加载完成，请刷新页面重试',
    containerNotReady: '容器未准备好，请重试',
    notLoggedIn: '未登录，请先登录',
    connected: 'VNC 连接成功',
    disconnectedClean: 'VNC 连接已断开',
    disconnectedError: 'VNC 连接异常断开: {{reason}}',
    unknownReason: '未知原因',
    passwordRequired: 'VNC 服务器需要密码',
    enterPassword: '请输入 VNC 密码: ',
    passwordNeeded: '需要 VNC 密码才能连接',
    securityFailed: 'VNC 密码错误或安全验证失败',
    clipboardSynced: '剪贴板已同步到本地',
    connectionFailed: '连接失败: ',
    authRetry: '认证失败，请重新输入密码...',
    ctrlAltDelSent: '已发送 Ctrl+Alt+Del',
    viewOnlyMode: '已切换到只读模式',
    interactiveMode: '已切换到交互模式',
    clipboardEnabled: '剪贴板同步已启用',
    clipboardDisabled: '剪贴板同步已禁用',
    qualityLevel: '画质级别: {{level}}',
    compressionLevel: '压缩级别: {{level}}',
    confirmReboot: '确定要重启远程机器吗？',
    remoteDesktopTitle: '远程桌面连接',
    pleaseFromDeviceList: '请从设备列表页面进入',
    connectToRemoteDesktop: '连接到远程桌面',
    device: '设备',
    username: '用户名',
    usernamePlaceholder: '系统登录用户名',
    vncPort: 'VNC 端口',
    portPlaceholder: '默认 5900',
    vncPassword: 'VNC 密码（可选）',
    vncPasswordPlaceholder: '如果 VNC 服务器需要密码',
    connectBtn: '连接',
    connecting: '正在连接...',
    fullscreen: '全屏',
    viewOnly: '只读',
    interactive: '交互',
    settings: '设置',
    disconnect: '断开',
    connectionSettings: '连接设置',
    clipboardSync: '剪贴板同步',
    readOnlyMode: '只读模式',
    qualityLabel: '画质级别',
    lowerIsHigher: '较低值=较高质量',
    compressionLabel: '压缩级别',
    higherIsStronger: '较高值=较强压缩',
    desktop: '桌面',
  },
};
